<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div class="immersion02">
    <NavBar />

    <div v-if="isWrongBrowser()">
      <h1>Bienvenue !</h1>
      <p>
        Oups, il semblerait que tu utilises un navigateur sur lequel notre site a du mal à fonctionner...
        <br />Pour jouer à ExploRêve, et plus généralement pour soutenir un développement libre d'internet, <br />nous
        t'invitons fortement à télécharger et utiliser Firefox, en allant
        <a href="https://www.mozilla.org/fr/firefox/new/">ici</a>
      </p>
      <img src="https://cdn.exploreve.fr/content/personnages/leon.svg" alt="leon" />
      <img src="https://cdn.exploreve.fr/content/personnages/daria.svg" alt="daria" />
      <img src="https://cdn.exploreve.fr/content/personnages/erwin.svg" alt="erwin" />
    </div>
    <div v-else>
      <div v-if="isMobile()">
        <h1>Bienvenue !</h1>
        <p>
          Pour entrer dans cette 2ème immersion, un ordinateur est nécessaire. En attendant, n'hésite pas nous rejoindre
          sur les réseaux sociaux, à parcourir le blog et à lire la page à propos pour en savoir plus sur le projet !
        </p>
        <img src="https://cdn.exploreve.fr/content/personnages/daria.svg" alt="daria" />
      </div>
      <router-view v-else @audio="setAudio" />
    </div>

    <audio id="musiccluedo" class="audio_music" loop>
      <source src="https://cdn.exploreve.fr/content/IM2/audio/music-cluedo-globale.mp3" />
    </audio>
    <audio id="musicvictoiremeca" class="audio_music">
      <source src="https://cdn.exploreve.fr/content/IM2/audio/music-meca-reussite-jingle-bravo.mp3" />
    </audio>
    <audio id="musichopital" class="audio_music" loop>
      <source src="https://cdn.exploreve.fr/content/IM2/audio/music-hopital-var-ballon-songe.mp3" />
    </audio>
    <audio id="musiclancementballonrepare" class="audio_music" loop>
      <source src="https://cdn.exploreve.fr/content/IM2/audio/music-ballon-repare-mondes-oniriques.mp3" />
    </audio>
    <audio id="musicsouvenirs" class="audio_music" loop>
      <source src="https://cdn.exploreve.fr/content/IM2/audio/music-souvenirs-memories.mp3" />
    </audio>
    <audio id="musicmarins" class="audio_music" loop>
      <source src="https://cdn.exploreve.fr/content/IM2/audio/music-marins-fleuve.mp3" />
    </audio>
    <SoundVolumeButton class="volume-button" @audio="setAudio" />
  </div>
</template>

<script>
// @ is an alias to /src
import NavBar from "@/components/NavBar.vue";
import SoundVolumeButton from "@/components/SoundVolumeButton.vue";

export default {
  name: "immersion02",
  components: {
    NavBar,
    SoundVolumeButton
  },
  data: function () {
    return {
      volume: 0.6,
      muted: false,
      musics: [
        "https://cdn.exploreve.fr/content/music/musique_1.mp3",
        "https://cdn.exploreve.fr/content/music/musique_2.mp3",
        "https://cdn.exploreve.fr/content/music/musique_3.mp3",
        "https://cdn.exploreve.fr/content/music/musique_4.mp3",
        "https://cdn.exploreve.fr/content/music/musique_5.mp3"
      ],
      currentMusic: null
    };
  },
  mounted: function () {
    this.currentMusic = document.getElementById("music04");
  },
  methods: {
    isMobile: function () {
      return document.documentElement.clientWidth < 760;
    },

    isWrongBrowser: function () {
      const ua = window.navigator.userAgent;
      return ua.indexOf("Edge") !== -1 || ua.indexOf("Edg") !== -1 || ua.indexOf("MSIE") !== -1;
    },

    pauseMusic: function (musicNode) {
      if (musicNode != null && musicNode != undefined && typeof musicNode.pause === "function") {
        musicNode.pause();
      }
    },

    playMusic: function (musicNode, loop) {
      if (musicNode != null && musicNode != undefined && typeof musicNode.play === "function") {
        musicNode.loop = loop || false;
        musicNode.muted = this.muted;
        musicNode.volume = this.volume;
        musicNode.play().catch(() => {});
      }
    },

    setAudio: function (music) {
      switch (music.action) {
        case "play": {
          this.pauseMusic(this.currentMusic);

          this.currentMusic = document.getElementById(music.id);
          this.playMusic(this.currentMusic, true);

          break;
        }
        case "play-once": {
          this.pauseMusic(this.currentMusic);

          let tmp = document.getElementById(music.id);
          this.playMusic(tmp, false);

          if (tmp != null && typeof tmp.addEventListener === "function") {
            tmp.addEventListener("ended", () => {
              this.playMusic(this.currentMusic, true);
            });
          }
          break;
        }
        case "pause":
          this.currentMusic.pause();
          break;
        case "mute":
          this.muted = music.muted;
          this.currentMusic.muted = music.muted;
          break;
        case "volume":
          this.volume = music.volume;
          this.currentMusic.volume = music.volume;
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.immersion02 {
  p {
    padding: 20px;
  }
  img {
    height: 300px;
    margin: auto;
    margin-bottom: 30px;
  }
  .volume-button {
    position: fixed;
    bottom: 50px;
    right: 0;
    margin: 30px;
  }
}
</style>
